import { render, staticRenderFns } from "./PublicResult.vue?vue&type=template&id=2b8f2238&scoped=true"
import script from "./PublicResult.vue?vue&type=script&lang=js"
export * from "./PublicResult.vue?vue&type=script&lang=js"
import style0 from "./PublicResult.vue?vue&type=style&index=0&id=2b8f2238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f2238",
  null
  
)

export default component.exports